export default __webpack_public_path__ + "static/media/share.871d175c.svg";